import { Stack, Switch, Typography } from '@mui/material';
import { useAppState } from '../context/LoadTestContext';
import { isUnloadStep } from './steps';

// The "Show unload steps" switch, with how many are hidden while it is off.
function ShowUnloadStepsSwitch({ size = 'small' }) {
  const { showUnloadSteps, setShowUnloadSteps, allStepSummaryData } = useAppState();
  const unloadCount = (Array.isArray(allStepSummaryData) ? allStepSummaryData : []).filter(isUnloadStep).length;
  return (
    <Stack component='label' direction='row' alignItems='center' spacing={0.5} sx={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
      <Switch
        size={size}
        checked={showUnloadSteps}
        onChange={(e) => setShowUnloadSteps(e.target.checked)}
        inputProps={{ 'aria-label': 'Show unload steps' }}
      />
      <Typography variant='caption' color='text.secondary'>
        Show unload steps{unloadCount ? ` (${unloadCount})` : ''}
      </Typography>
    </Stack>
  );
}

export default ShowUnloadStepsSwitch;
